<div class="container">
  <h1>Settings</h1>
  <div class="row mb-2">
    <pub-termweb-connection-settings></pub-termweb-connection-settings>
  </div>
  <div class="row mb-2">
    <pub-scheduled-sync-settings></pub-scheduled-sync-settings>
  </div>
  <div class="row mb-2">
    <pub-localization-settings></pub-localization-settings>
  </div>
</div>
